import { FC, ReactElement } from "react";
import {
  FormControl,
  FormLabel,
  InputGroup,
  FormErrorMessage,
  InputProps,
} from "@chakra-ui/react";
import { useField } from "formik";

interface Props extends InputProps {
  children: ReactElement;
  id: string;
  label?: string;
  meta: ReturnType<typeof useField>[1];
  minH?: string;
}

export const InputWrapperSimple: FC<Props> = ({
  children,
  id,
  label,
  meta,
}) => {
  return (
    <FormControl isInvalid={meta.touched && !!meta.error}>
      {label && <FormLabel htmlFor={id}>{label}</FormLabel>}

      <InputGroup>{children}</InputGroup>

      <FormErrorMessage>{meta.error}</FormErrorMessage>
    </FormControl>
  );
};
